import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters } from 'vuex';
import ratingQuery from '~/graphql/merchant/rating.gql';
var CONTEXT = 'http://schema.org';
var BRAND = 'Maisons du Monde';
var TYPE = 'Organization';
export default {
  name: 'RatingJsonLd',
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),

  head() {
    return {
      script: [{
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': CONTEXT,
          '@type': TYPE,
          name: BRAND,
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: this.rating.value,
            ratingCount: this.rating.count,
            bestRating: '5.00'
          }
        })
      }]
    };
  },

  apollo: {
    rating: {
      query: ratingQuery,

      variables() {
        return {
          locale: this.locale.iso
        };
      }

    }
  },
  render: h => h(null)
};